import adarsh_pic from "../assets/adarsh.png";

export const Introduction = () => {
  return (
    <section className="intro_photo">
      <div className="intro">
        <h3>Hie, This is</h3>
        <h1>"Adarsh Kumar"</h1>
        <h3>and I am <span className="multiple-text"></span></h3>
        <p>I’m Adarsh Kumar — a builder at heart, blending technology with purpose. My journey started with a curiosity for how systems work, and it has grown into a passion for creating solutions that are reliable, scalable, and empowering.
          <br />
As the founder of Texure, I’ve architected platforms like Brij Health Care and Research Center and Brij Sewa Sadan, where backend stability meets intuitive design. I specialize in backend deployment, process automation, and error-proofing workflows, but what excites me most is seeing technology make life easier for people — whether it’s a patient logging in seamlessly or an admin managing data with confidence.
<br />
My tech stack spans Django, React (Vite), MongoDB, VPS hosting, and PM2 process management, but I don’t just code — I design experiences. I believe dashboards should empower, not overwhelm, and that uptime isn’t just a metric, it’s trust.
<br />
Beyond the screen, I’m a motivator and organizer. I’ve led student programs, delivered speeches, and built communities where learning and innovation thrive. For me, technology is not just about servers and scripts — it’s about people, impact, and the stories we create together.
</p>
        <div className="social_media">
          <a href="https://www.facebook.com/coderadarsh/" target="_blank" rel="noreferrer" style={{i: 1}}><i className='bx bxl-facebook'></i></a>
          <a href="https://www.instagram.com/ethicaladarsh/" target="_blank" rel="noreferrer" style={{i: 2}}><i className='bx bxl-instagram'></i></a>
          <a href="https://www.linkedin.com/in/ethicaladarsh/" target="_blank" rel="noreferrer" style={{i: 3}}><i className='bx bxl-linkedin'></i></a>
          <a href="https://github.com/ethicaladarsh" target="_blank" rel="noreferrer" style={{i: 4}}><i className='bx bxl-github'></i></a>
        </div>
      </div>
      <div className="image_man">
        <img src={adarsh_pic} alt="This is not loaded.........!" id="main_img" />
      </div>
    </section>
  );
};